import React, { useState } from "react";

import forgetpassword from "../../images/fp-g.svg";
import { Link } from "react-router-dom";
import ScrollToTop from "../ScrollToTop";
import axios from "axios";
import Header from "../../Component/Header";

const MyAccountForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      await axios.post("https://sakhisshop.com/api/customers/reset-password", {
        email,
        frontendUrl: "https://sakhisshop.com", // reset link open hoga is frontend me
      });
      setMessage("✅ Reset link sent to your email!");
    } catch (err) {
      setMessage(err.response?.data?.error || "❌ Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ScrollToTop />
      <Header />
      <section className="my-lg-14 my-8">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            {/* Left side image */}
            <div className="col-12 col-md-6 col-lg-4 order-lg-1 order-2">
              <img src={forgetpassword} alt="freshcart" className="img-fluid" />
            </div>

            {/* Right side form */}
            <div className="col-12 col-md-6 offset-lg-1 col-lg-4 order-lg-2 order-1 d-flex align-items-center">
              <div>
                <div className="mb-lg-9 mb-5">
                  <h1 className="mb-2 h2 fw-bold">Forgot your password?</h1>
                  <p>
                    Please enter the email address associated with your account
                    and we will email you a link to reset your password.
                  </p>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-12">
                      <input
                        type="email"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="Email"
                        value={email}
                        required
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <span className="navbar-text">
                        Already have an account?{" "}
                        <Link to="/MyAccountSignIn">Sign in</Link>
                      </span>
                    </div>

                    {/* Message */}
                    {message && (
                      <div className="col-12">
                        <p
                          className={
                            message.startsWith("✅")
                              ? "text-success"
                              : "text-danger"
                          }
                        >
                          {message}
                        </p>
                      </div>
                    )}

                    {/* Buttons */}
                    <div className="col-12 d-grid gap-2">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Sending..." : "Reset Password"}
                      </button>
                      <Link
                        to="/CustomerProfileRegistration"
                        className="btn btn-light"
                      >
                        Back
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyAccountForgetPassword;
